import { VehicleTelemetryRepository, VehicleTelemetryRepositoryFactory } from 'core/repositories/FMS/VehicleTelemetryRepository';
import { ignore } from 'utility/ignore';

export class DummyTelemetryRepositoryFactory implements VehicleTelemetryRepositoryFactory {
    create(projectId: string): Promise<VehicleTelemetryRepository> {
        ignore(projectId);
        throw new Error('Method not implemented.');
    }

    destroy(repository: VehicleTelemetryRepository): Promise<void> {
        ignore(repository);
        throw new Error('Method not implemented.');
    }
}
